import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WizardService } from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-wizard-navigation',
  templateUrl: './wizard-navigation.component.html',
  styleUrls: ['./wizard-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizardNavigationComponent implements OnInit {
  @Input() hideBackButton: boolean = false;
  @Input() disableContinueButton: boolean = false;
  @Input() previousStepRoute: string = "";
  @Input() nextStepRoute: string = "";
  @Input() isStartStep: boolean = false;
  @Input() currentStepName: string = "";
  @Input() currentStepNumber: number = 0;

  totalSteps: number = 0;

  constructor(private wizardService: WizardService) { }

  ngOnInit(): void {
    this.totalSteps = this.wizardService.getTotalStepCount();
  }

  getPreviousStepNumber(): number {
    return this.currentStepNumber - 1;
  }

  getNextStepNumber(): number {
    return this.currentStepNumber + 1;
  }
}
